import { useMutation, useQuery } from "react-query";
import { getHistoriesLookups, getHistories, restoreInventory } from "@/api/Histories/histories-api";

export const key = "histories";

export function useHistoriesLookups(filters, options = {}) {
	return useQuery([key, "lookups", filters], () => getHistoriesLookups(filters), {
		...options,
	});
}

export function useHistories(type, filters, options = {}) {
	return useQuery([key, "list", type, filters], () => getHistories(type, filters), {
		enabled: Boolean(type),
		...options,
	});
}

export function useRestoreInventory(options = {}) {
	return useMutation(restoreInventory, {
		...options,
	});
}
